import React from 'react';
import { TableHead, TableRow } from '@material-ui/core';
import { TableCell } from '@material-ui/core';
import { NoBorderCell } from 'components/common/table/TableStyle';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import { memberClosetTableColumn } from '../memberClosetTableBody/memberClosetTableColumn';

interface Props {
  totalGroup: number;
}

const MemberClosetTableHeader = ({ totalGroup }: Props) => {
  return <DataTableHeader header={memberClosetTableColumn} />;
};

export default MemberClosetTableHeader;
